import * as React from "react";

import { 
    Course,
    HowItWorks,
    OurClients,
    OurTeam,
} from '~/components/homepage';

export default function InfoOurSite(props: any) {
    return (
        <div className="InfoOurSite">
            <div className="container">
                <Course />
                <HowItWorks />
                <OurClients />
                <OurTeam />
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/homepage/InfoOurSite.tsx